import { IndexContainer, IndexHeader, CardGrid, IndexCard } from '../../../styles/global'

export function MansoryIndex() {
  const gradient = 'linear-gradient(135deg, #d35400 0%, #e67e22 100%)'
  const accentColor = '#d35400'

  const calculators = [
    {
      title: 'Flexão',
      description: 'Calculadora para análise de flexão em elementos de alvenaria',
      path: '/alvenaria/flexao',
      icon: '📐',
      popular: true,
    },
    {
      title: 'Verificação de Parede',
      description:
        'Verificação de paredes de alvenaria estrutural considerando carregamentos e características da parede',
      path: '/alvenaria/parede',
      icon: '✅',
      popular: true,
    },
    {
      title: 'Cisalhamento',
      description: 'Calculadora para análise de cisalhamento em elementos de alvenaria',
      path: '/alvenaria/cisalhamento',
      icon: '✂️',
      popular: false,
    },
    {
      title: 'Painel',
      description: 'Esforços em paineis sob ação lateral fora do plano',
      path: '/alvenaria/painel',
      icon: '🧱',
      popular: false,
    },
    {
      title: 'Compressão',
      description: 'Calculadora para análise de compressão em elementos de alvenaria',
      path: '/alvenaria/compressao',
      icon: '⬇️',
      popular: false,
    },
  ]

  return (
    <IndexContainer>
      <IndexHeader $gradient={gradient}>
        <div className="header-content">
          <h1>🧱 Alvenaria Estrutural</h1>
          <p className="subtitle">
            Ferramentas completas para dimensionamento e verificação de elementos estruturais em alvenaria
          </p>
          <div className="stats">
            <div className="stat-item">
              <span className="stat-number">{calculators.length}</span>
              <span className="stat-label">Calculadoras</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{calculators.filter((c) => c.popular).length}</span>
              <span className="stat-label">Mais Usadas</span>
            </div>
          </div>
        </div>
      </IndexHeader>

      <div className="content-wrapper">
        <h2>Calculadoras Disponíveis</h2>
        <CardGrid>
          {calculators.map((calc, index) => (
            <IndexCard
              key={index}
              to={calc.path}
              $popular={calc.popular}
              $gradient={gradient}
              $accentColor={accentColor}
            >
              {calc.popular && <span className="popular-badge">Popular</span>}
              <span className="card-icon">{calc.icon}</span>
              <h3>{calc.title}</h3>
              <p>{calc.description}</p>
              <span className="arrow">→</span>
            </IndexCard>
          ))}
        </CardGrid>
      </div>
    </IndexContainer>
  )
}
